import { useEffect, useState, type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { authApi } from '../lib/api';

type GuardState = 'checking' | 'ok' | 'login';

export default function AdminGuard({ children }: { children: ReactNode }) {
  const [state, setState] = useState<GuardState>('checking');

  useEffect(() => {
    let cancelled = false;
    void authApi
      .me()
      .then(() => {
        if (!cancelled) setState('ok');
      })
      .catch(() => {
        if (!cancelled) setState('login');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (state === 'checking') {
    return (
      <main className="grid min-h-screen place-items-center bg-[#fbfaf7] text-sm text-[#4d5550]">
        Checking session…
      </main>
    );
  }
  if (state === 'login') return <Navigate to="/admin/login" replace />;
  return children;
}
